



































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class SalesChargeView extends Vue {
  public items: Common.SalesCharge[] = new Array(0);
  public params: Common.ChargeQuery = new Common.ChargeQuery(Common.SalesPurchaseFlags.Sales);
  // public importQuery = new Common.ChargeImportQuery('売上諸掛',Common.SalesPurchaseFlags.Sales);
  public exportQuery = new Common.ChargeExportQuery('売上諸掛',this.params,Common.SalesPurchaseFlags.Sales);
  public usedTypes = Common.UsedTypes; 
  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'chargeNo', text: '諸掛番号' },
    { value: 'chargeDate', text: '発生日' },
    { value: 'counterpart', text: '諸掛取引先' },
    { value: 'segment', text: '部門' },
    { value: 'pic', text: '担当者' },
    { value: 'refNo', text: '諸掛管理番号' },
    { value: 'deliveryNo', text: '按分先伝票番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];
  @Prop() public chargeNo:string;
  public proportionalDivisionFlags = Common.ProportionalDivisionFlags;
  public calcUtil: Common.CalcUtil = new Common.CalcUtil();
  public chargeItemTypeDefault = Common.ChargeItemTypes.Default;    
  public deliveryItemStatus = Common.StockBalanceJournalStatus;  
  // 一覧可変表示用プロパティ
  public hasLicenseCurrency: boolean = false;  
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');

  // 支払情報タブ可変表示用プロパティ
  public paymentTabCaptions = new Array();
  public paymentTabWidths = new Array();
  public paymentTabSlots = new Array();
  public paymentTabGridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'col');

  //按分明細タブ
  public gridConfigItems :Common.GridConfiguration = new Common.GridConfiguration([],0, 'col');
  //按分先入荷明細グリッド
  public gridConfigChargeItems :Common.GridConfiguration = new Common.GridConfiguration([],0, 'col');
  public tenantSettings: Common.TenantSettings = null;
  public chargeStatus = Common.ChargeStatus;
  // ワークフロー処理用プロパティ
  public buttonNames: Array<string> = null;
  public buttonIndexIdArray: Array<{index:number,actionId:number}> =null;

  public created() {
    // 検索条件を設定する
    if(this.chargeNo) {
      this.params.chargeNo = this.chargeNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
        
    this.tenantSettings = this.$api.tenantSettings;

    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    // 一覧表示項目の制御
    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 150),
      new Common.GridItemConfiguration('諸掛番号', 150),
      new Common.GridItemConfiguration('ワークフロー', 220),
      new Common.GridItemConfiguration('発生日', 150),
      new Common.GridItemConfiguration('諸掛取引先', 150),
      new Common.GridItemConfiguration('勘定科目', 150),
      new Common.GridItemConfiguration('取引通貨', 150,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('取引金額', 150),
      new Common.GridItemConfiguration('税区分', 150),
      new Common.GridItemConfiguration('計上レート', 150,this.hasLicenseCurrency),      
      new Common.GridItemConfiguration('按分方法', 150),
      new Common.GridItemConfiguration('部門', 150),
      new Common.GridItemConfiguration('担当者', 150),
      new Common.GridItemConfiguration('諸掛管理番号', 150),
      new Common.GridItemConfiguration('按分先伝票番号', 150),      
      new Common.GridItemConfiguration('支払予定日', 150),
      new Common.GridItemConfiguration('税抜金額', 150),
      new Common.GridItemConfiguration('消費税額', 150),
      new Common.GridItemConfiguration('税込金額', 150),
      new Common.GridItemConfiguration('未支払金残高', 150),
      new Common.GridItemConfiguration('計上金額', 150,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('計上税額', 150,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('税込計上額', 150,this.hasLicenseCurrency),      
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150),
    );
    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;

    this.paymentTabGridConfig.setGridItems(
      new Common.GridItemConfiguration('支払伝票番号', 150),
      new Common.GridItemConfiguration('消込', 120),
      new Common.GridItemConfiguration('支払日', 120),
      new Common.GridItemConfiguration('支払通貨', 150,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('支払レート', 150,this.hasLicenseCurrency),      
      new Common.GridItemConfiguration('支払額', 150),
      new Common.GridItemConfiguration('支払計上額', 150,this.hasLicenseCurrency),      
    );
    this.paymentTabCaptions = this.paymentTabGridConfig.gridCaptions;
    this.paymentTabWidths = this.paymentTabGridConfig.gridWidths;
    this.paymentTabSlots = this.paymentTabGridConfig.gridSlots;


    //'明細区分','諸掛明細番号','出荷明細番号','取引先','出荷日','商品','商品名称','SKU','数量','単位','計上金額','諸掛按分額'
    this.gridConfigItems.setGridItems(
      new Common.GridItemConfiguration('明細区分', 150),
      new Common.GridItemConfiguration('諸掛明細番号', 150),
      new Common.GridItemConfiguration('出荷明細番号', 150),
      new Common.GridItemConfiguration('取引先', 150),
      new Common.GridItemConfiguration('出荷日', 150),
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('商品名称', 150),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('数量', 150),
      new Common.GridItemConfiguration('単位', 150),
      new Common.GridItemConfiguration('計上金額', 150),
      new Common.GridItemConfiguration('諸掛按分額', 150),      
    );

    this.gridConfigItems.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,false,true,'',false));

    //'出荷明細番号', '得意先', '商品', 'SKU', '出荷管理番号', '出荷日', '数量', '単位', '計上金額',
    this.gridConfigChargeItems.setGridItems(
      new Common.GridItemConfiguration('出荷明細番号', 150),
      new Common.GridItemConfiguration('得意先', 150),
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('出荷管理番号', 150),
      new Common.GridItemConfiguration('出荷日', 150),
      new Common.GridItemConfiguration('数量', 150),
      new Common.GridItemConfiguration('単位', 150),
      new Common.GridItemConfiguration('計上金額', 150),
    );    
    this.gridConfigChargeItems.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,false,false,''));//初期表示

  }


  public savingFlag: Common.ChargeStatus = Common.ChargeStatus.ChargeSaving;

  public async onCreate(obj: Common.SalesCharge) {
    const workflows = this.$api.formatter.getOptions('workflow_charge');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    obj.pic = this.$api.auth.userId;
    
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  // 取引先変更時に取引先の通貨・支払予定日を設定する
  public onChangeCounterpart(item: Common.Charge, editor: Components.Editor){
    if(editor.isEdit == false) return;
    item.currencyCode = item.counterpart ? item.counterpart.currencyCode : '';
    item.taxCode = item.counterpart ? item.counterpart.taxCode : '';
    this.onChangeChargeDate(item, editor);
  }

  // 発生日変更時に支払予定日を設定する
  public onChangeChargeDate(item: Common.Charge, editor: Components.Editor){
    if(editor.isEdit == false) return;
    if(item.counterpart == null || item.chargeDate == null) item.dueDate = null;
    else 
    {
      var closginDate = item.counterpart.getClosingDate(item.chargeDate, this.tenantSettings);
      item.dueDate = item.counterpart.getPaymentDate(closginDate, this.tenantSettings);
    }

    this.onChangeCurrency(item);
  }

  // 発生日・通貨が変更された場合、計上レートを取得する
  public async onChangeCurrency(item: Common.Charge){
    this.getExchangeRate(item.currencyCode, item.chargeDate)
    .then(res => {
      item.exchangeRate = res;
    });
  }

  public async getExchangeRate(currencyCode: string, startDate: Date):Promise<any>{
    const query = new Common.GetExchangeRateQuery();
    query.currency = currencyCode;
    query.startDate = startDate;
    let rate = 1;
    await this.$api.execute(query).then(res => {
      const exchangeRate = res as Common.ExchangeRate;
      rate = exchangeRate ? exchangeRate.rate : 1;
    });
    return rate;
  }

  // 一覧でチェックされている諸掛
  public checkedCharges: Array<Common.Charge>= new Array(0);
  public getCheckedCharges(){
    this.checkedCharges = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        obj.writeoffAmountFC = 0;
        this.checkedCharges.push(obj);
      }
    });
  }
  selected: Common.Charge;
  // 一覧選択時に諸掛按分明細タブ、支払情報タブを更新
  public onSelectedMain(index: number, selected: Common.Charge) {
    this.selected = selected;
    // 諸掛按分明細タブを更新
    this.chargeItems = new Array(0);
    if(index >= 0) this.refreshChargeItemtList();
    
    // 支払情報タブを更新
    this.totalPaymentAmountFC = 0;
    this.totalPendingAmountFC = 0;
    this.paymentJournals = new Array(0);
    if(index >= 0) this.refreshPaymentList();
  }

  // 諸掛按分明細タブ更新用プロパティ
  public isLoading: boolean = false;
  public chargeItems: Common.ChargeItem[]= new Array(0);

  // 諸掛按分明細タブを更新
  public async refreshChargeItemtList(){
    this.isLoading = true;
    
    const temp = (this.$refs.mainList as Components.ListView).selected;
    var query = new Common.ChargeItemQuery();
    query.chargeNo = temp.chargeNo;

    // サーバーから諸掛按分明細を取得する
    return this.$api.execute(query).then(res => {
      if((this.$refs.mainList as Components.ListView).isInsertMode == false){
        res = res as Common.LoadResult;
        this.chargeItems = res.result;
      }
    }).finally(()=>{
      this.isLoading = false;
    });
  }

  // 支払情報タブ更新用プロパティ
  public totalPaymentAmountFC:number = 0;
  public totalPendingAmountFC:number = 0;      
  public paymentJournals: Common.TransferJournal[]= new Array(0);

  // 支払情報タブを更新
  public refreshPaymentList(){
    this.isLoading = true;
    var totalWriteoffAmountFC = 0;
    var totalWriteoffPendingAmountFC = 0;        
    var charge = (this.$refs.mainList as Components.ListView).selected as Common.Charge;
    var query = new Common.PaymentJournalQuery();
    query.voucherNo = charge.chargeNo;
    query.isSend = true;
    // サーバーから前払金適用額を取得する
    this.$api.execute(query).then(res => {
      res = res as Common.LoadResult;
      this.paymentJournals = res.result;
      this.paymentJournals.forEach((obj, index) => {
          if (obj.isPosted) {
            totalWriteoffAmountFC += obj.amountFC;
            obj.state = Common.PaymentStatus.PaymentCompleted;
          } else {
            totalWriteoffPendingAmountFC += obj.amountFC;
            obj.state = Common.PaymentStatus.PaymentPostWaiting;            
          }        
      });
    }).finally(()=>{
      this.isLoading = false;
      this.totalPaymentAmountFC = totalWriteoffAmountFC;
      this.totalPendingAmountFC = totalWriteoffPendingAmountFC;                  
    });
  }
  // 支払一覧へ遷移する
  public onPaymentNoClick(paymentNo: string){
    this.$router.push(String.format('/cash/Withdrawal?paymentNo={0}',paymentNo));
  }

  // 支払処理用プロパティ
  public dpSegment: Common.Segment = null;
  public dpPic: string = '';
  public dpWorkflowId:number =0;
  public dpCounterpart: Common.Counterpart = null;
  public dpCurrencyCode: string = '';
  public dpPaymentDate: Date = new Date;
  public dpBankAccount: Common.BankAccount = null;
  public dpExchageRate: number = 0;
  public get dpPaymentAmountFC(): number { return this.dpSettlementAmountFC + this.dpCommissionAmountFC; };
  public dpCommissionAmountFC: number = 0;
  public dpCommissionTaxFlag: boolean = false;
  public get dpSettlementAmountFC(): number {
    if(this.checkedCharges.length == 0) return 0;
    return this.checkedCharges.map(obj => obj.writeoffAmountFC).reduce((total, value) =>(total + value));
  };
  public dpMin(delivery:any): number{
    if (delivery.pendingBalanceAmountFC > 0) return 0;
    else return delivery.pendingBalanceAmountFC;    
    // if(delivery.paymentBalance == null) return 0;
    // if(delivery.paymentBalance.currentAmountFC > 0) return 0;
    // return delivery.paymentBalance.currentAmountFC;
  }
  public dpMax(delivery:any): number{
    if (delivery.pendingBalanceAmountFC < 0) return 0;
    else return delivery.pendingBalanceAmountFC;        
    // if(delivery.paymentBalance == null) return 0;
    // if(delivery.paymentBalance.currentAmountFC < 0) return 0;
    // return delivery.paymentBalance.currentAmountFC;
  }
   public showDeliveryPaymentDialog2() {
    this.checkedCharges = new Array(0);
    this.checkedCharges.push(this.selected);
    this.showDeliveryPaymentDialogExec();
   }
  // 支払処理ダイアログの表示
  public showDeliveryPaymentDialog() {
    this.getCheckedCharges();

    // ダイアログ表示前バリデーション
    if(this.checkedCharges.length == 0){
      this.$api.modal.show('', '対象の伝票を選択して下さい。', true, null);             
      return;
    }
    if(this.checkedCharges.filter(charge=> this.checkedCharges[0].counterpart.id != charge.counterpart.id).length > 0){
      this.$api.modal.show('', '取引先の異なる諸掛を、同じ支払伝票にまとめることはできません。', true, null);
      return;
    }
    if(this.checkedCharges.filter(charge=> this.checkedCharges[0].currencyCode != charge.currencyCode).length > 0){
      this.$api.modal.show('', '取引通貨の異なる諸掛を、同じ支払伝票にまとめることはできません。', true, null);
      return;
    }
    if(this.checkedCharges.filter(charge=> this.checkedCharges[0].segmentId != charge.segmentId).length > 0){
      this.$api.modal.show('', '部門の異なる諸掛を、同じ支払伝票にまとめることはできません。', true, null);
      return;
    }        
    if(this.checkedCharges.filter(charge=> (charge.state == Common.ChargeStatus.ChargeSaving)).length > 0){
      this.$api.modal.show('', '伝票が未確定です。', true, null);
      return;
    }
    if(this.checkedCharges.filter(charge=> (charge.state == Common.ChargeStatus.Completed)).length > 0){
      this.$api.modal.show('', '支払が完了しています。', true, null);
      return;
    }

    this.showDeliveryPaymentDialogExec();
  }
  public showDeliveryPaymentDialogExec() {
    // プロパティの初期化
    this.dpSegment = this.checkedCharges[0].segment; //発生部門をセット(非表示)
    this.dpPic = this.$api.auth.userId;    
    this.dpWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_sendPayment');
    this.dpCounterpart = this.checkedCharges[0].counterpart;
    this.dpCurrencyCode = this.checkedCharges[0].currencyCode;
    this.dpPaymentDate = new Date;
    this.dpExchageRate = 1;
    this.dpCommissionAmountFC = 0;
    this.dpCommissionTaxFlag = true; // 販売管理では課税固定
    this.onChangeDpCurrency();
    this.getBankAccount();
    this.onDeliveryPaymentChangeWorkflow();

    // ダイアログの表示
    (this.$refs.deliveryPaymentDialog as Components.ListDialog).items = this.checkedCharges;
    (this.$refs.deliveryPaymentDialog as Components.ListDialog).showDialog();
  }

  public onChangeDpCurrency(){
    const query = new Common.GetExchangeRateQuery();
    query.currency = this.dpCurrencyCode;
    query.startDate = this.dpPaymentDate;
    this.$api.execute(query).then(res => {
      const exchangeRate = res as Common.ExchangeRate;
      this.dpExchageRate = exchangeRate ? exchangeRate.rate : 1;
    });    
  }
  public onDeliveryPaymentChangeWorkflow(){
    this.buttonNames=new Array();
    this.buttonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.buttonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.buttonNames.push("支払保存");
    if(this.dpWorkflowId!=0)
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('sendPayment', this.dpWorkflowId, Common.PaymentStatus.PaymentPostWaiting);
      actions.forEach(action => {
        this.buttonNames.push(action.actionName);
        this.buttonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }
  }
  public async getBankAccount(){
    const query = new Common.GetBankAccount();
    query.currencyCode = this.dpCurrencyCode;
    this.$api.execute(query).then(res => {
      this.dpBankAccount = res as Common.BankAccount;
    });
  }

  // 支払処理の実行
  public async submitDeliveryPayment(list: Array<Common.Charge>, index:number) {
    // クエリの設定
    var query = new Common.ChargePaymentQuery();
    query.isSalesCharge = true;
    query.segment = this.dpSegment;
    query.pic = this.dpPic;
    query.workflowId = this.dpWorkflowId;
    query.counterpart = this.dpCounterpart;
    query.currencyCode = this.dpCurrencyCode;
    query.paymentDate = this.dpPaymentDate;
    query.bankAccount = this.dpBankAccount;
    query.exchangeRate = this.dpExchageRate;
    query.commissionAmountFC = this.dpCommissionAmountFC;
    query.settlementAmountFC = this.dpSettlementAmountFC;
    query.commissionTaxFlag = this.dpCommissionTaxFlag;
    query.charges = list;
    query.actionId = this.buttonIndexIdArray.filter(obj => obj.index==index)[0].actionId;

    // 支払処理の実行
    // await this.$api.execute(query).then(res => {
    //   //this.$router.push('/cash/Withdrawal');
    //   this.$router.push(String.format('/cash/WithDrawal?paymentNo={0}',(res as Common.Payment).paymentNo));        
    // });

    return this.$api.execute(query,true).then(res => {
      //リストリロード=>支払明細タブのリロード
      (this.$refs.mainList as Components.ListView).reload().then(()=>this.refreshPaymentList());
      var payment = res as Common.Payment;
      //this.$api.modal.show('処理結果','以下の支払伝票が作成されました。',true,null,[new Common.ModalLink(payment.paymentNo, String.format('/cash/WithDrawal?paymentNo={0}',payment.paymentNo))]);
      this.$api.modal.show('処理結果','以下の支払伝票が作成されました。',false,()=>this.$router.push(String.format('/cash/WithDrawal?paymentNo={0}',payment.paymentNo)),[new Common.ModalLink(payment.paymentNo, String.format('/cash/WithDrawal?paymentNo={0}',payment.paymentNo))],'伝票に移動する','閉じる');
      return true;
    }).catch(()=>{return false;});                
  }

  // 按分先伝票選択用プロパティ
  public deliveries: Array<Common.Delivery> = new Array();
  public dsParams: Common.DeliveryQuery = new Common.DeliveryQuery(Common.SalesPurchaseFlags.Sales);
  
  // 按分先伝票選択ダイアログの表示
  public showDeliverySelectDialog() {
    // バリデーション
    if(this.chargeItems.length > 0) return;

    // プロパティの初期化
    this.deliveries = new Array();
    this.dsParams = new Common.DeliveryQuery(Common.SalesPurchaseFlags.Sales);
    
    // ダイアログの表示
    (this.$refs.deliverySelectDialog as Components.ListDialog).showDialog();
  }

  // 按分先伝票の抽出
  public async onChangeDsPrams(){
    var count = 0;
    this.$api.startWaitCusor();
    await this.$api.execute(this.dsParams).then((data: Common.LoadResult) => {
      this.deliveries = data.result;
    }) 
    .finally(() => {
      this.$api.formatter.loadPendingLists();
      this.$api.closeWaitCursor();
    });
  }

  // 諸掛按分明細追加(出荷伝票)の実行
  public async submitAddChargeItemByDelivery(){
    var deliveries:Array<any> = (this.$refs.deliveryListBox as Components.Grid).items;

    if (deliveries.length == 0){
        this.$api.closeWaitCursor();      
        return this.$api.modal.showDialog('無効な操作','按分先伝票を選択してください。').then(()=>{return false;});
    }

    // 選択している出荷伝票の取得
    var selectedId = (this.$refs.deliveryListBox as Components.Grid).selectedId;
    var delivery = deliveries[selectedId];
    
    var charge = (this.$refs.mainList as Components.ListView).selected as Common.Charge;
    charge.deliveryNo = delivery.deliveryNo;

    // クエリの設定
    var query = new Common.AddDeliveryChargeItemQuery();
    query.charge = charge;
    
    // 諸掛按分明細追加の実行
    // await this.$api.execute(query)
    // .finally(() => this.refreshChargeItemtList());

    return this.$api.execute(query).then(res => {
      //リストリロード
      (this.$refs.mainList as Components.ListView).onSubmit(res);
      //諸掛明細のロード
      return this.refreshChargeItemtList().then(()=>{return true;});

    }).catch(()=>{return false;});              
  }

  // 按分先明細選択用プロパティ
  public deliveryItems: Array<Common.DeliveryItem> = new Array();
  public disParams: Common.DeliveryItemQuery = new Common.DeliveryItemQuery(Common.SalesPurchaseFlags.Sales);

  // 按分先明細選択ダイアログの表示
  public showDeliveryItemSelectDialog() {
    // プロパティの初期化
    this.deliveryItems = new Array();
    this.disParams = new Common.DeliveryItemQuery(Common.SalesPurchaseFlags.Sales);
    
    // ダイアログの表示
    (this.$refs.deliveryItemSelectDialog as Components.ListDialog).showDialog();
  }

  // 按分先明細の抽出
  public async onChangeDisPrams(){
    var count = 0;
    this.$api.startWaitCusor();
    await this.$api.execute(this.disParams).then((data: Common.LoadResult) => {
      this.deliveryItems = data.result;
    }) 
    .finally(() => {
      this.$api.formatter.loadPendingLists();
      this.$api.closeWaitCursor();
    });
  }

  // 諸掛按分明細追加(出荷明細)の実行
  public async submitAddChargeItemByDeliveryItem(){
    // 選択している出荷伝票の取得
    var deliveryItems: Array<Common.DeliveryItem> = new Array();
    var grid = this.$refs.deliveryItemListBox as Components.Grid
    grid.items.forEach((obj, index) => {
      if (grid.checked[index]) deliveryItems.push(obj);
    });
    

    if (deliveryItems.length == 0){
        this.$api.closeWaitCursor();
        return this.$api.modal.showDialog('無効な操作','按分先明細を選択してください。').then(()=>{return false;});
    }

    var charge = (this.$refs.mainList as Components.ListView).selected as Common.Charge;
    charge.deliveryNo = '';

    // クエリの設定
    var query = new Common.AddDeliveryChargeItemQuery();
    query.charge = charge;
    query.deliveryItems = deliveryItems;
    
    // 諸掛按分明細追加の実行
    // await this.$api.execute(query)
    // .finally(() => this.refreshChargeItemtList());

    return this.$api.execute(query).then(res => {
      //リストリロード
      (this.$refs.mainList as Components.ListView).onSubmit(res);
      //諸掛明細のロード
      return this.refreshChargeItemtList().then(()=>true);
    }).catch(()=>{return false;});      
  }

  // 諸掛按分明細削除の実行
  public submitDeleteChargeItem() {
    // 明細が0件の場合は、何もしない
    var items:Array<any> = (this.$refs.chargeItemListBox as Components.Grid).items;
    if(items.length == 0) return;

    // 選択している諸掛・明細の取得
    var charge = (this.$refs.mainList as Components.ListView).selected as Common.Charge;
    var selectedId = (this.$refs.chargeItemListBox as Components.Grid).selectedId;
    var chargeItem = items[selectedId];

    // クエリの設定
    var query = new Common.DeleteChargeItemQuery();
    query.charge = charge;
    query.chargeItemId = chargeItem.id;

    // 明細削除の実行
    this.$api.startWaitCusor();
    this.$api.execute(query).then(res =>{
      this.refreshChargeItemtList();
      charge.deliveryNo = '';
    })
    .finally(() => this.$api.closeWaitCursor());
  }

  //関連伝票ダイアログを表示
  public showDirectAccessDialg(item:Common.SalesCharge){
    this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.SalesCharge, sourceNo : item.chargeNo},this.$el);
  }  


  //按分明細の削除
  public async onDelete(){

      var selectedItems = (this.$refs.chargeItemListBox as Components.Grid).selectedItems;
      if (selectedItems.length == 0){
      this.$api.modal.show('無効な操作', '削除する行を選択してください。', true, null);
      return Promise.reject();        
      }
      (selectedItems as Common.ChargeItem[]).forEach(item => item.counterpart = null); //counterpartが原因でサーバー側でエラーが発生するため暫定対応～同一オブジェクトを異なるインスタンスで保持していることが原因のよう
      return this.$api.modal.showDialog('確認メッセージ', selectedItems.length + '件のデータを本当に削除してよろしいですか?', false).then(async ()=>{
        
        for(let item of selectedItems){        
          await this.$api.remove(item);
        }
        //明細番号が変わるのでリスト全体をリロードする必要がある
        this.refreshChargeItemtList();
        return Promise.resolve();
      });
  }      
    
  public showDeliveryItem:boolean = false;  //入荷明細一覧を表示して按分明細を追加する

  public showAddItems(item: Common.SalesCharge){
    this.showDeliveryItem = true;
  }


  public onAddDeliveryItems(charge : Common.PurchaseCharge){

    var selectedItems = ((this.$refs.salesDeliveryItem as Components.SalesDeliveryItem).$refs.mainList as Components.ListView).selectedItems as Common.SalesDeliveryItem[];
    
    //入荷明細一覧の諸掛按分処理でのバリデーションを移植(部門は伝票部門との一致を確認)
    if(selectedItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);
      return;
    }    
    if(selectedItems.filter(item => item.state == Common.StockBalanceJournalStatus.SalesDeliveryInstructionWaiting ||  item.state == Common.StockBalanceJournalStatus.SalesDelivering).length > 0){
      this.$api.modal.show('', '出荷指示・出荷待ちの明細は選択できません。', true, null);
      return;
    }
    if(selectedItems.filter(item => item.segment.id != charge.segment.id).length > 0){
      this.$api.modal.show('', '部門の異なる出荷明細を追加することはできません。', true, null);
      return;
    }

    var query = new Common.AddChargeAllocationQuery();
    query.allocationOnly = true;    
    query.charges = [charge];
    query.deliveryItems =selectedItems;
    this.$api.startWaitCusor();
    this.$api.execute(query).then(()=>{
      this.$api.closeWaitCursor();      
      this.showDeliveryItem = false;
      this.refreshChargeItemtList();
    });
  }  
}
